// components/Loader.jsx
import React from 'react';
import '../styles/loader.css';

const Loader = () => {
  return (
    <div className="loader-overlay">
      <div className="loader-container">
        {/* Your Logo - Replace with your actual logo */}
        <div className="loader-logo">
          <div className="heart-shape"></div>
        </div>
        
        {/* Animated heart pulse */}
        <div className="heart-pulse"></div>
        
        {/* Loading text */}
        <p className="loader-text">Finding your perfect match...</p>
      </div>
    </div>
  );
};

export default Loader;